export default __webpack_public_path__ + "static/media/visa_mastercard.d28b2958.png";